module.exports = __webpack_public_path__ + "static/media/angle-down.f89bc5ea.svg";